import type { ChatBackend } from 'entities/CommunicationService'

export enum ThemeTenants {
  default = 'default',
  nicorette = 'nicorette',
}
export enum AvailableCampaigns {
  default = 'default',
  nicorettePilot = 'nicorettePilot',
  dpQuestionGatherer = 'dp_questionGatherer',
  dpRegaine = 'dp_regaine',
  dpAllegyAdvice = 'dp_allergieberatung',
  dpLoceryl = 'dp_loceryl',
  dpSupplements = 'dp_supplements',
  dpVigantol = 'dp_vigantol',
  ccBeiersdorfSun = 'cc_beiersdorfSun',
  ccLorealSun = 'cc_lorealSun',
  dpVitaminAdvice = 'dp_vitaminAdvice',
  dpPainkillers = 'dp_painkillers',
  dpGinko = 'dp_ginko',
  ccRegaineMen = 'cc_regaineMen',
  ccRegaineWomen = 'cc_regaineWomen',
  dpInsectProtection = 'dp_InsectProtection',
  dpPainAdvice = 'dp_Pain-Advice',
  ccSkinceuticals = 'cc_skinceuticals',
  ccImodiumAkut = 'cc_imodiumAkut',
  ccEucerinBody = 'cc_eucerinBody',
  dpColdAdvice = 'dp_cold-advice',
}
export interface ThemeCSSProperties {
  [key: string]: string
}

export enum TargetTypes {
  datalayer = 'datalayer',
  querystring = 'querystring',
  pathname = 'pathname',
}

export enum ProductCardTemplates {
  default = 'default',
  compact = 'compact',
}

interface BaseTargeting {
  type: TargetTypes
  value: any
}

export interface TargetingDatalayer extends BaseTargeting {
  path: string
}

export interface TargetingQuerystring extends BaseTargeting {
  key: string
}

export type TargetType =
  | BaseTargeting
  | TargetingDatalayer
  | TargetingQuerystring

export interface AdServerProperties {
  decisionName: string
  adType: number
  viewEventId: number
  placeEventId: number
  tag?: string
}

export interface MessageDelaySettings {
  delayPerCharacter: number
  minDelay?: number // milliseconds
  maxDelay?: number // milliseconds
}

export interface ThemeConfig<Campaigns = AvailableCampaigns> {
  id: Campaigns
  palette: ThemeCSSProperties
  cssProperties: ThemeCSSProperties
  name: string
  logo?: string
  buttonLogo?: string
  chatTitle?: string
  welcomeMessage?: string
  initialIntent?: string
  emptyResponseIntent?: string
  backend: ChatBackend
  targeting?: Array<TargetType>
  adServerProperties?: AdServerProperties
  sponsored?: boolean
  productCardTemplate?: ProductCardTemplates
  disclaimer?: string
  messageDelay?: MessageDelaySettings
  styleRichText?: boolean
  linkableCampaigns?: Array<AvailableCampaigns>
}

export type ThemesListConfig<Campaigns extends string = AvailableCampaigns> = {
  [key in Campaigns]: ThemeConfig<Campaigns>
}

export enum Tenants {
  COM = 'com',
  BE = 'be',
  IT = 'it',
}

export enum Languages {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  NL = 'nl',
  IT = 'it',
}

export interface RawThemesListConfig extends ThemesListConfig {
  global: {
    [key in Tenants]: {
      [k in Languages]: {
        showWidget: boolean
        hiddenPages?: Array<string>
      }
    }
  }
}
